import React, { useEffect, useState } from "react";
import {
  Box,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  Tooltip,
  Typography,
  useTheme,
  useMediaQuery,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { InputField, RadioInputField } from "../../../components/ui/Inputs";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SelectOptions from "../../../components/ui/SelectOptions";
import { PrimaryButton, SecondaryButton } from "../../../components/ui/Button";
import { useForm, Controller } from "react-hook-form";
import filterIcon from "./../../../assets/images/icons/filter.png";
import Tables from "../../../components/ui/Tables";
import ModalPopup from "../../../components/ui/ModalPopup";
import BasicDatePicker from "../../../components/ui/BasicDatePicker";
import { formatIndianRupees } from "../../../utils/formatting";
import { RootState } from "../../../services/redux/store";
import { useDispatch, useSelector } from "react-redux";
import service from "../../../services/api/service";
import {
  authSelector,
  userLoanCatSelector,
  userPermissionSelector,
} from "../../../services/redux/slices/authSlice";
import postsServices from "../../../services/api/service/postsService";
import Toast from "../../../components/ui/Toast";
import PaperCard from "../../../components/ui/PaperCard";
import InfoIcon from "./../../../assets/images/icons/info.png";
import { filterOptionsPay, messages } from "../../../data/constant";
import dayjs from "dayjs";
import { formatDate } from "../../../utils/dateFormatUtils";
import { register } from "../../../serviceWorkerRegistration";
import {
  clearStatusPopup,
  setStatusPopup,
} from "../../../services/redux/slices/statusPopupSlice";
import LoaderBackdrop from "../../../components/ui/LoaderBackdrop";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../routes/routerConfig";
import { setUnreadCount } from "../../../services/redux/slices/notificationSlice";
import notificationsServices from "../../../services/api/service/notificationService";
import { encrypt, decrypt, decryptObject } from "../../../utils/crypto";
import { paymentLimit } from "../../../data/constant";
import Card from "../../../components/ui/Card";
import HeadingLeftRight from "../../../components/ui/HeadingLeftRight";
import CardItemListFlexi from "../../../components/ui/mobile/CardItemListFlexi";
import ButtonLoader from "../../../components/ui/ButtonLoader";
import AccountSelectorDropDown from "../../../components/ui/AccountSelectorDropDown";

interface Column {
  field: string;
  headerName: string;
  align?: "right";
  format?: (value: any) => string;
}
interface TableColumn {
  id: string;
  label: string;
  align?: "right";
  format?: (value: any) => string;
}
interface DashboardItemType {
  loanType: any;
  totalLimit: any;
  availableLimit: any;
  outstanding: any;
  overdueAmount: any;
  overdueBreakup: any;
  overdueTotal: any;
  overDueCharges: any;
  fees: any;
  dashboardData: any;
  totalPrincipalOutstanding: any;
  statusOfLoan: any;
}
export interface RowData {
  [key: string]: string | number | null;
}

export interface VirtualAccountData {
  accNumber: string;
  ifscCode: string;
  accName: string;
  bankName: string;
  status: string;
}

const MyPayments = () => {
  const { handleSubmit, control, getValues, register, setValue } = useForm();

  // State hooks
  const [selected, setSelected] = useState("0");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [overdueAmount, setOverdueAmount] = useState(0);
  const [selectedOptionValue, setSelectedOptionValue] = useState<
    string | number
  >("");
  const { userProfile } = useSelector(authSelector);
  const { rolePermissions } = useSelector(userPermissionSelector);
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [dashboardData, setDashboardData] = useState<any>();
  const [selectedOptionFilterValue, setSelectedOptionFilterValue] = useState<
    string | number
  >("");
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");
  const [inputValue, setInputValue] = useState("");
  const [nagitiveValueCheck, setNagitiveValueCheck] = useState("");
  const [disabledButton, setdisabledButton] = useState(false);
  const [lanNumber, setLanNumber] = useState("");
  const [toastOpen, setToastOpen] = useState(false);
  const [paymentTypeValue, setPaymentTypeValue] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const [pending, setPending] = useState(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [rows, setRows] = useState<RowData[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [statusUpdate, setstatusUpdate] = useState("");
  const [virtualAccountData, setVirtualAccountData] =
    useState<VirtualAccountData | null>(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { businessType } = useSelector(authSelector);
  const userLoanCategory = useSelector(userLoanCatSelector);
  const businessTypeId = useSelector(
    (state: RootState) => state?.auth?.businessType?.id
  );
  const loanCategoryData: any = useSelector(
    (state: RootState) => state?.auth?.loanCategory
  );
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  // --------------------------------------------------code for URL Data----------------------------------------
  const parseCustomQueryString = (queryString: any) => {
    const cleanedQueryString = queryString.startsWith("?")
      ? queryString.substring(1)
      : queryString;

    const correctedQueryString = cleanedQueryString.replace(/\?/g, "&");

    const paramPairs = correctedQueryString.split("&");

    const params: any = {};

    paramPairs.forEach((pair: any) => {
      const [key, value] = pair.split("=");

      if (key && value) {
        params[decodeURIComponent(key)] = decodeURIComponent(value);
      }
    });

    return params;
  };
  const parsedParams = parseCustomQueryString(window.location.search);
  let cif: any;
  let LoanNo: any;
  let paymentId: any;
  let lan: any;
  let paymentType: any;

  if ("error" in parsedParams) {
    cif = parsedParams["amp;cif"];
  } else {
    cif = parsedParams.cif;
  }
  if ("error" in parsedParams) {
    LoanNo = parsedParams["loanNo"];
  } else {
    LoanNo = parsedParams["LoanNo"];
  }
  if ("error" in parsedParams) {
    paymentId = parsedParams["paymentid"];
  } else {
    paymentId = parsedParams["paymentid"];
  }
  if ("error" in parsedParams) {
    paymentType = parsedParams["paymentType"];
  } else {
    paymentType = parsedParams["paymentType"];
  }
  if ("error" in parsedParams) {
    lan = parsedParams["LoanNo"];
  } else {
    lan = parsedParams["LoanNo"];
  }

  const paymentRequestId = parsedParams["paymentRequestId"];

  const getNotificationsUnreadCounts = async () => {
    try {
      const bodyObj: any = {};
      let cifEntity = userProfile?.cifEntity;
      //bodyObj.cifEntity = cifEntity;
      bodyObj.businessType = encrypt(businessTypeId);
      bodyObj.loanCategory = encrypt(
        loanCategoryData?.TermLoan[0]?.loanCategoryId
      );
      const res = await notificationsServices.getNotifications(bodyObj);
      if (res?.status == 200 && res?.data?.data) {
        dispatch(
          setUnreadCount(res?.data?.pagination?.unreadNotificationsCounts)
        );
      }
    } catch (error) {
      console.error("get notifications API error::", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (paymentRequestId !== undefined) {
        setIsLoading(true);
        const payload = {
          // LoanNo: encrypt(LoanNo),
          paymentRequestId: encrypt(paymentRequestId),
          cif: encrypt(parsedParams?.cif),
          business: businessType?.id,
          loanCategory: userLoanCategory?.Flexi[0]?.loanCategoryId,
          paymentId: encrypt(paymentId),
          lan: encrypt(lan),
          // paymentType: encrypt(paymentType),
        };

        const apiEndpoint = `api/v1/payment/update-payment-status`;

        const timeoutDuration = 4000;

        try {
          // Promises for API call and timeout
          const apiCallPromise = service.posts.addPost(apiEndpoint, payload);

          const timeoutPromise = new Promise((_, reject) =>
            setTimeout(() => {
              reject(new Error(messages.paymentErrorMessages.timeout));
            }, timeoutDuration)
          );

          const response: any = await Promise.race([
            apiCallPromise,
            timeoutPromise,
          ]);

          setIsLoading(false);

          let status = response?.data?.data?.status;
          let resData = response?.data?.data;
          setstatusUpdate(resData);
          if (status === "Success") {
            getNotificationsUnreadCounts();
            dispatch(
              setStatusPopup({
                status: "success",
                message: `Your payment transaction of Rs. ${resData?.paidAmount} has been successfully processed with payment reference number ${resData?.transcationReferenceNo}, Payment will reflect in your account in next 1 hour.`,
                locationPath: ROUTES?.Dashboard?.flexiTermLoan?.locationPath,
              })
            );
          } else if (status === "Failed") {
            getNotificationsUnreadCounts();
            dispatch(
              setStatusPopup({
                status: "error",
                message: `Your payment transaction of Rs. ${resData?.failedAmount} has failed. Please try again. `,
                locationPath: ROUTES?.Dashboard?.flexiTermLoan?.locationPath,
              })
            );
          } else if (status === "In Progress") {
            dispatch(
              setStatusPopup({
                status: "success",
                message: messages.paymentErrorMessages.inProgress,
                locationPath: ROUTES?.Dashboard?.flexiTermLoan?.locationPath,
              })
            );
          }
        } catch (error: any) {
          setIsLoading(false);
          const errorMessage = error.response?.data?.message;
          dispatch(
            setStatusPopup({
              status: "error",
              message: errorMessage,
              locationPath: ROUTES?.Dashboard?.flexiTermLoan?.locationPath,
            })
          );
        }
      }
    };

    // Call fetchData function
    fetchData();

    // Cleanup function (optional)
    return () => {
      // Any cleanup code if needed
    };
  }, [paymentRequestId, cif, LoanNo, paymentId, lan]);
  // --------------------------------------------------code for URL Data----------------------------------------
  const handleToastClose = () => {
    setToastOpen(false);
  };

  const handleFilterButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedOptionFilterValue("");
    setFromDate(null);
    setToDate(null);
  };

  const handleListItemClick = (option: any) => {
    setValue("amount", "");
    setErrorMessage("");
    localStorage.setItem("payType", option === "1" ? "OverDue" : "PartPayment")
    setSelected(option);
    if (option === "1") {
      setPaymentTypeValue("overdue");
    } else {
      setPaymentTypeValue("PartPayment");
    }
  };
  // Redux selectors
  // -------------------------------------New Code---------------------------------------
  const selectedLoanNumber = useSelector(
    (state: RootState) => state.dashboardData.selectedLoanNumber
  );
  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  useEffect(() => {
    const matchedObject = dashboardDataSet.find(
      (data: any) => data.loanAccountNumber === selectedLoanNumber
    );
    setDashboardData(matchedObject);
    setErrorMessage("");
    setValue("amount", "");
  }, [selectedLoanNumber]);
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setdisabledButton(false);
    let value = e.target.value.replace(/\D/, "");
    const numericValue = parseInt(value, 10);
    const outstandingValue = dashboardData?.totalPrincipalOutstanding / 100 - 2;
    const outstandingValueBefourMin =
      dashboardData?.totalPrincipalOutstanding / 100;
    const overDueValue = dashboardData?.overdueAmount / 100;

    const inputValue: any = e.target.value;

    if (inputValue > paymentLimit) {
      setErrorMessage(
        "Per transaction limit for Part Payment and Overdue Payment is 9 Lakhs"
      );
      return;
    }

    if (inputValue < 0) {
      e.target.value = "0";
    }
    if (selected === "2") {
      if (numericValue > outstandingValue) {
        value = outstandingValue.toString();
        if (outstandingValueBefourMin <= 2 && outstandingValueBefourMin > 0) {
          setErrorMessage(messages.paymentErrorMessages.partPayment);
        } else {
          setErrorMessage(
            `${messages.paymentErrorMessages.partPayment2} ${outstandingValue}`
          );
        }
      } else {
        setErrorMessage("");
      }
      setInputValue(value);
      setNagitiveValueCheck(e.target.value);
    } else if (selected === "1") {
      if (numericValue > overDueValue) {
        value = overDueValue.toString();
        setErrorMessage(messages.paymentErrorMessages.overdue);
      } else {
        setErrorMessage("");
      }
      setInputValue(value);
      setNagitiveValueCheck(inputValue);
    }
  };
  // -------------------------------------New Code---------------------------------------
  const selectedOption = useSelector(
    (state: RootState) => state.option.selectedOption
  );
  const loanAccountNumberOptions = useSelector(
    (state: RootState) => state.option.loanAccountNumberOptions
  );

  useEffect(() => {
    if (loanAccountNumberOptions && loanAccountNumberOptions.length > 0) {
      setLanNumber(loanAccountNumberOptions[0]);
    }
  }, [loanAccountNumberOptions]);

  useEffect(() => {
    if (
      selectedOption &&
      loanAccountNumberOptions &&
      loanAccountNumberOptions.length > 0
    ) {
      const selectedLAN = loanAccountNumberOptions.find(
        (option: any) => option === selectedOption
      );
      if (selectedLAN) {
        setLanNumber(selectedLAN);
      }
    }
  }, [selectedOption, loanAccountNumberOptions]);
  const sanctionedDisbursedData = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  // Fetch and filter dashboard data based on selectedOption
  useEffect(() => {
    const filteredDashboardData = sanctionedDisbursedData?.filter(
      (item: any) => {
        return item.loanAccountNumber === selectedOption;
      }
    );
    // setDashboardData(filteredDashboardData);
    setOverdueAmount(
      filteredDashboardData.length > 0
        ? filteredDashboardData[0].overdueAmount
        : 0
    );
  }, [sanctionedDisbursedData, selectedOption]);

  // Effect to update dashboard data and overdue amount based on selectedloanAccountNumber
  const selectedloanAccountNumber = useSelector(
    (state: RootState) => state.option.selectedloanAccountNumber
  );
  useEffect(() => {
    const filteredDashboardData = sanctionedDisbursedData?.filter(
      (item: any) => {
        return item.loanAccountNumber === selectedloanAccountNumber;
      }
    );
    // setDashboardData(filteredDashboardData);
    setOverdueAmount(
      filteredDashboardData.length > 0
        ? filteredDashboardData[0].overdueAmount
        : 0
    );
  }, [selectedloanAccountNumber]);

  // Columns for table
  const columns: Column[] = [
    {
      field: "created_at",
      headerName: "Transaction date",
      format: (value: any) => formatDate(value),
    },
    { field: "paymentRequestId", headerName: "Transaction Id" },
    {
      field: "transcationReferenceNo",
      headerName: "Transaction Ref.No",
      format: (value: any) => value || "-",
    },
    { field: "type", headerName: "Type" },
    { field: "amount", headerName: "Request Amount" },
    { field: "paidAmount", headerName: "Paid Amount" },
    { field: "customerName", headerName: "Initiated by" },
    {
      field: "newStatus",
      headerName: "Status",
    },
  ];

  const tableColumns: TableColumn[] = columns.map((c) => ({
    id: c.field,
    label: c.headerName,
    align: c.align,
    format: c.format,
  }));

  // Update selected state based on overdueAmount
  const handleFromDateChange = (date: Date | null) => {
    if (date) {
      const fromDateDayjs = dayjs(date);
      setFromDate(fromDateDayjs.toDate());
    } else {
      setFromDate(null);
    }
  };
  const handleToDateChange = (date: Date | null) => {
    if (date) {
      const toDateDayjs = dayjs(date);
      setToDate(toDateDayjs.toDate());
    } else {
      setToDate(null);
    }
  };
  const fetchData = async () => {
    setIsLoading(true);
    const formattedFromDate = fromDate
      ? dayjs(fromDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = toDate ? dayjs(toDate).format("YYYY-MM-DD") : "";
    const statusQuery =
      selectedOptionFilterValue === "all"
        ? ""
        : `status=${selectedOptionFilterValue}&`;

    const pageSkip = page + 1; // API might be 1-based indexing
    const pageSize = rowsPerPage;
    const queryString = `?lan=${selectedLoanNumber}&${statusQuery}startDate=${formattedFromDate}&endDate=${formattedToDate}&pageSkip=${pageSkip}&pageSize=${pageSize}`;

    try {
      const response = await service.posts.getPosts(
        `api/v1/payment/payment-list${queryString}`
      );
      setRows(response.data.data);
      setTotalRecords(response.data.pagination.total_rows);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }

    setIsLoading(true);

    // Define the required payload structure for the API call
    const payload = {
      lan: encrypt(selectedLoanNumber),
    };
    postsServices
      .addPost("/api/v1/virtual-payment/fetch-details", payload)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.data) {
          const decryptedData = decryptObject(
            response.data.data
          ) as VirtualAccountData;
          if (decryptedData && decryptedData.accNumber) {
            setVirtualAccountData(decryptedData);
          } else {
            setVirtualAccountData(null);
          }
        } else {
          setVirtualAccountData(null);
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        dispatch(setStatusPopup({ status: "error", message: errorMessage }));
        setIsLoading(false);
      });
  };
  useEffect(() => {
    fetchData();
  }, [selectedLoanNumber, page, rowsPerPage, statusUpdate]);
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    fetchData();
  };
  const filterData = () => {
    setPage(0);
    setRowsPerPage(5);
    fetchData();
    setIsModalOpen(false);
    setSelectedOptionFilterValue("");
    setFromDate(null);
    setToDate(null);
  };

  // Form submission handler
  const onSubmit = (data: any) => {
    setIsLoading(true);
    const formData = getValues();
    let combinedData: any = {
      cif: decrypt(userProfile?.cifNumber),
      cifEntity: decrypt(userProfile?.cifEntity),
      amount: formData.amount,
      lan: selectedLoanNumber.toString(),
      // lan: "MUMRE00002716",
      initiatedBy: decrypt((userProfile?.id).toString()),
      paymentType: paymentTypeValue,
      loanType: dashboardData?.loanType,
      business: businessType?.id,
      loanCategory: userLoanCategory?.Flexi[0]?.loanCategoryId,
      // successurl: "http://localhost:3000/dashboard/basic-tabs?cif=99208",
      //  : "http://localhost:3000/dashboard/basic-tabs?fail=1&cif=99208",
    };
    let jsonData = JSON.stringify(combinedData);
    let encryptedPayload = {
      data: encrypt(jsonData),
      // business: businessType?.id,
      // loanCategory: userLoanCategory?.Flexi[0]?.loanCategoryId,
    };
    // API call to add payment request
    postsServices
      .addPost("api/v1/payment/request", encryptedPayload)
      .then((response) => {
        setIsLoading(false);
        const successMessage = response?.data?.message || "success";
        let paymentURL = response.data.data.shortURL;
        window.open(paymentURL, "_self");
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.message || "An error occurred";
        dispatch(setStatusPopup({ status: "error", message: errorMessage }));
        setIsLoading(false);
      });
  };
  useEffect(() => {
    const matchedObject = dashboardDataSet.find(
      (data: any) => data.loanAccountNumber === selectedLoanNumber
    );
    let check = matchedObject?.overdueAmount / 100;
    if (check > 0 || isNaN(check)) {
      setSelected("1");
      setPaymentTypeValue("Overdue");
    } else {
      setSelected("2");
      setPaymentTypeValue("PartPayment");
    }
  }, []);
  useEffect(() => {
    const matchedObject = dashboardDataSet.find(
      (data: any) => data.loanAccountNumber === selectedLoanNumber
    );
    let check = matchedObject?.overdueAmount / 100;
    if (check > 0 || isNaN(check)) {
      setSelected("1");
      setPaymentTypeValue("Overdue");
    } else {
      setSelected("2");
      setPaymentTypeValue("PartPayment");
    }
  }, [selectedLoanNumber]);
  // Add this state for payment type selection
  const [selectedPaymentType, setSelectedPaymentType] = useState<string>("");
  const handlePaymentTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSelectedPaymentType(event.target.value);
  };
  const tabType = useSelector((state: RootState) => state.tabs.tabType);

  return (
    <Grid sx={{ paddingTop: isXsOrSm ? "5px" : "20px" }}>
      {isXsOrSm && (
        <>
          <Box>
            <Typography
              sx={{
                fontWeight: "700",
                fontSize: "14px",
                letterSpacing: "1px",
                color: "#168794",
                paddingBottom: "15px",
              }}
            >
              Payment
            </Typography>
          </Box>
        </>
      )}
      {/* Main Card Section - Updated to match PaymentRequestTermLoan.tsx style, preserving all radio button conditions and input box */}
      <Card borderColor={!isXsOrSm}>
        <Grid container>
          <Grid item sm={12} sx={{ height: "28px" }}>
            {isXsOrSm ? (
              <AccountSelectorDropDown
                labelText="Loan account number"
                buttonText=" N/A"
                isActive={""}
                backgroundColor="transparent"
                borderWidth="0px"
                marginTop="0px"
              />
            ) : (
              <>
                <Typography
                  variant="h6"
                  className="loan-account-main-heading"
                  style={{ marginBottom: "5px" }}
                >
                  Loan A/c {dashboardData?.loanAccountNumber}
                </Typography>
                <Typography
                  variant="subtitle1"
                  className="loan-account-sub-heading"
                >
                  {dashboardData?.productType || ""}
                </Typography>
              </>
            )}
          </Grid>
        </Grid>
        <Grid container sx={{ paddingTop: isXsOrSm ? "12px" : "25px" }}>
          <Divider
            sx={{
              border: isXsOrSm ? "" : "1px solid rgba(219, 218, 222, 1)",
              borderColor: isXsOrSm ? "rgba(0, 0, 0, 0.12)" : "",
              borderBottomWidth: isXsOrSm ? "thin" : "",
              width: "100%",
            }}
          />
        </Grid>
        <Grid
          container
          spacing={1}
          className={`${isXsOrSm ? "statement-container-mobile" : ""}`}
        >
          <Grid item xs={12} sm={6}>
            <Grid
              container
              spacing={2}
              className={
                isXsOrSm ? "dashboard-container-mobile" : "dashboard-container"
              }
            >
              <Grid item xs={6} sm={6} md={6} mt={2}>
                <Typography
                  className={
                    isXsOrSm ? "insidePageLableMobile" : "insidePageLable"
                  }
                >
                  Total Limit
                </Typography>
                <Typography
                  className={
                    isXsOrSm ? "insidePageValueMobile" : "insidePageValue"
                  }
                  variant="subtitle1"
                >
                  {formatIndianRupees(dashboardData?.totalLimit)}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={6} mt={2}>
                <Typography
                  className={
                    isXsOrSm ? "insidePageLableMobile" : "insidePageLable"
                  }
                >
                  Available Limit
                </Typography>
                <Typography
                  className={
                    isXsOrSm ? "insidePageValueMobile" : "insidePageValue"
                  }
                >
                  {formatIndianRupees(dashboardData?.availableLimit)}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={6}>
                <Typography
                  className={
                    isXsOrSm ? "insidePageLableMobile" : "insidePageLable"
                  }
                >
                  Principal Outstanding Amount
                </Typography>
                <Typography
                  className={
                    isXsOrSm ? "insidePageValueMobile" : "insidePageValue"
                  }
                >
                  {formatIndianRupees(dashboardData?.totalPrincipalOutstanding)}
                </Typography>
              </Grid>
              <Grid item xs={6} sm={6}>
                <Typography
                  className={
                    isXsOrSm ? "insidePageLableMobile" : "insidePageLable"
                  }
                >
                  Overdue Amount
                </Typography>
                <Typography
                  className={
                    isXsOrSm ? "insidePageValueMobile" : "insidePageValue"
                  }
                >
                  {formatIndianRupees(dashboardData?.overdueAmount)}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* Vertical Divider for desktop */}
          {!isXsOrSm && (
            <Grid item sm={1} sx={{ paddingTop: "31px !important" }}>
              <div className="line2-container">
                <div className="line vertical"></div>
                <div className="line vertical"></div>
              </div>
            </Grid>
          )}
          {/* Right column: payment type, input box, and button */}
          <Grid
            container
            justifyContent={isXsOrSm ? "flex-start" : "center"}
            alignItems={isXsOrSm ? "flex-start" : "center"}
            sm={5}
            xs={12}
            sx={{
              marginLeft: isXsOrSm ? "" : "-9px",
              marginBottom: isXsOrSm ? "10px" : "0px",
            }}
            width="100%"
          >
            <Box
              display="flex"
              flexDirection="column"
              alignItems={isXsOrSm ? "flex-start" : "center"}
              justifyContent={isXsOrSm ? "flex-start" : "center"}
              gap={1}
              width="100%"
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent={isXsOrSm ? "flex-start" : "center"}
                gap={2}
                className={
                  isXsOrSm
                    ? "dashboard-container-mobile"
                    : "dashboard-container"
                }
                width="100%"
              >
                {/* Part Payment Radio with original condition and updated design */}
                <Box display="flex" alignItems="center">
                  <RadioInputField
                    checked={selected === "2"}
                    onClick={() => handleListItemClick("2")}
                    disabled={dashboardData?.overdueAmount / 100 > 0}
                  />
                  <Typography className="paymentRadioItem">
                    Part Payment
                  </Typography>
                </Box>
                {/* Overdue Radio with original condition and updated design */}
                <Box display="flex" alignItems="center">
                  <RadioInputField
                    checked={selected === "1"}
                    onClick={() => handleListItemClick("1")}
                    disabled={
                      dashboardData?.overdueAmount / 100 > 100 ||
                      dashboardData?.overdueAmount <= 0
                    }
                  />
                  <Typography className="paymentRadioItem">Overdue</Typography>
                </Box>
              </Box>
              {/* Input box for payment amount, unchanged */}
              <Box
                width={isXsOrSm ? "100%" : "240px"}
                mt={0}
                sx={{ paddingLeft: isXsOrSm ? "6px" : "0px" }}
              >
                <InputField
                  fullWidth
                  placeholder="Enter amount"
                  {...register("amount")}
                  type="number"
                  autoComplete="off"
                  onChange={handleInputChange}
                  inputProps={{ maxLength: 2 }}
                  error={!!errorMessage}
                  helperText={errorMessage}
                  disabled={dashboardData?.statusOfLoan != "A"}
                />
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems={isXsOrSm ? "flex-start" : "center"}
                justifyContent={isXsOrSm ? "flex-start" : "center"}
                gap={4}
                marginTop={2}
                width="100%"
                sx={{ marginLeft: isXsOrSm ? "5px" : "0px" }}
              >
                <PrimaryButton
                  type="submit"
                  width={isXsOrSm ? "100%" : "240px"}
                  disabled={
                    inputValue.trim() === "" ||
                    parseFloat(nagitiveValueCheck.trim()) <= 0 ||
                    errorMessage.trim() != "" ||
                    disabledButton ||
                    isLoading
                  }
                  onClick={handleSubmit(onSubmit)}
                >
                  <ButtonLoader title="Pay Now" isLoading={isLoading} />
                </PrimaryButton>
              </Box>
            </Box>
          </Grid>
        </Grid>
        {tabType === "Flexi Term Loan" && virtualAccountData?.accNumber && (
          <Grid
            container
            style={{
              background: "#ebf9f9",
              marginTop: "10px",
              padding: "5px 15px",
              borderRadius: "5px",
            }}
          >
            {/* Heading */}
            <Grid item xs={12} mt={2}>
              <HeadingLeftRight titleone="To make Payment through NEFT/RTGS/IMPS, please use below account details" />
            </Grid>

            {/* Card Section */}
            <Grid item xs={12}>
              <Box className="dashboard-container">
                <Grid container spacing={1}>
                  {/* Account Number */}
                  <Grid item xs={6} sm={6} md={3}>
                    <Typography className="insidePageLable">
                      Account Number
                    </Typography>
                    <Typography variant="subtitle1" className="insidePageValue">
                      {virtualAccountData?.accNumber}
                    </Typography>
                  </Grid>

                  {/* Account Name */}
                  <Grid item xs={6} sm={6} md={3}>
                    <Typography className="insidePageLable">
                      Account Name
                    </Typography>
                    <Typography variant="subtitle1" className="insidePageValue">
                      {virtualAccountData?.accName}
                    </Typography>
                  </Grid>

                  {/* Loan Number */}
                  <Grid item xs={6} sm={6} md={3}>
                    <Typography className="insidePageLable">
                      Bank Name
                    </Typography>
                    <Typography variant="subtitle1" className="insidePageValue">
                      {virtualAccountData?.bankName}
                    </Typography>
                  </Grid>

                  {/* IFSC Code */}
                  <Grid item xs={6} sm={6} md={3}>
                    <Typography className="insidePageLable">
                      IFSC Code
                    </Typography>
                    <Typography variant="subtitle1" className="insidePageValue">
                      {virtualAccountData?.ifscCode}
                    </Typography>
                  </Grid>

                  {/* Status */}

                  {/* Notes */}
                  <Grid item xs={12}>
                    <Typography
                      variant="subtitle1"
                      className="insidePageValue"
                      style={{ padding: "5px 0px" }}
                    >
                      <b>Notes : </b>
                    </Typography>
                    <Typography className="insidePageLable">
                      • The payment made in above account will not reflect in
                      below table. Please refer SOA for the transactions.
                      <br />• Funds will be credited in Loan Account on T+1
                      working day.
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        )}
      </Card>
      {/* Information Section */}
      {/* <Grid item xs={12} sm={4} md={4} lg={4}>
          <PaperCard>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Typography variant="h2" className="heading-text">
                Important payment related information
              </Typography>
            </Grid>
            <ul className="ul-style" style={{ marginBottom: 0 }}>
              <li>
                <ListItemText primary="You can visit the payment section to pay your overdue amount and make a part payment." />
              </li>
              <li>
                <ListItemText primary="A convenience fee will be applied to cover the cost of processing the transaction." />
              </li>
              <li>
                <ListItemText primary="If there is an overdue amount, please pay it first before making the part payment." />
              </li>
              <li>
                <ListItemText primary="Successful transactions will be reflected in the account an hour after the payment is made." />
              </li>
            </ul>
          </PaperCard>
        </Grid> */}
      {/* Previous Payment Requests Section */}

      <Grid container marginTop={2}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Grid item>
                <Typography className="loan-account-main-heading">
                  Previous Payment Requests
                </Typography>
              </Grid>
              {!isXsOrSm && (
                <Grid item style={{ display: "inline-flex" }} gap={2}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontFamily: "Jost",
                      fontSize: "clamp(9px, 1.2vw, 11px)",
                      fontWeight: "500",
                      lineHeight: "19.36px",
                      textAlign: "left",
                      color: "#00B3B5",
                      width: "fit-content",
                      height: "27px",
                      padding: "14px 12px",
                      borderRadius: "4px",
                      border: "0.5px solid #00B3B5",
                      cursor: "pointer",
                    }}
                    onClick={handleFilterButtonClick}
                  >
                    <img
                      src={filterIcon}
                      alt="Filter Icon"
                      style={{ width: "13px", color: "#00B3B5" }}
                    />{" "}
                    Filter
                  </span>
                </Grid>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ marginTop: "20px" }}
            >
              {isXsOrSm ? (
                <CardItemListFlexi columns={columns} rows={rows} />
              ) : (
                <Tables
                  columns={tableColumns}
                  rows={rows}
                  page={page}
                  isLoading={isLoading}
                  rowsPerPage={rowsPerPage}
                  totalRecords={totalRecords}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
        {/* Filter Modal Popup */}
        <Toast
          open={toastOpen}
          message={message}
          severity={severity}
          onClose={handleToastClose}
        />
        <ModalPopup
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          title="Filter"
          onNavigate={() => { }}
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            padding: "16px 16px 63px 16px",
            margin: "0px",
            borderRadius: "8px 0px 0px 8px",
            height: "100vh",
            width: "340px",
            zIndex: 9999,
          }}
        >
          <SelectOptions
            options={filterOptionsPay}
            label="Select Option"
            isMandatory={false}
            value={selectedOptionFilterValue}
            onChange={(value: string | number) => {
              setSelectedOptionFilterValue(value);
            }}
          />
          <BasicDatePicker
            label="From Date"
            width="100%"
            onChange={handleFromDateChange}
            value={fromDate ? dayjs(fromDate) : null}
          />
          <BasicDatePicker
            label="To date"
            width="100%"
            onChange={handleToDateChange}
            value={toDate ? dayjs(toDate) : null}
          />
          <PrimaryButton
            fullWidth
            type="submit"
            onClick={filterData}
            style={{ margin: "20px 0px" }}
          >
            Apply
          </PrimaryButton>
        </ModalPopup>
      </Grid>
      {/* <LoaderBackdrop open={isLoading} /> */}
    </Grid>
  );
};

export default MyPayments;